var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "assessment-border"
  }, [_c('h1', {}, [_vm._v("Ask Your Teacher for Help!")]), _c('div', {
    staticClass: "assessment-info"
  }, [_vm._m(0), _c('input', {
    ref: "inputfield",
    staticClass: "initials-textfield",
    attrs: {
      "aria-label": "Teacher initials",
      "type": "text",
      "id": "inputfield"
    },
    domProps: {
      "value": _vm.initials
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue($event.target.value);
      }
    }
  }), _c('p', {
    staticClass: "input-note"
  }, [_vm._v("(Minimum 2 characters)")]), _c('div', {
    staticClass: "assessment-choices"
  }, [_c('div', {
    staticClass: "assessment-choice"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.initialsEntered === false
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.teacherDirection('quit');
      }
    }
  }, [_vm._v("\n          SKIP\n        ")]), _c('p', [_vm._v("This activity is too advanced for my student.")])]), _c('div', {
    staticClass: "assessment-choice"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.initialsEntered === false
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.teacherDirection('retry');
      }
    }
  }, [_vm._v("\n          RETRY\n        ")]), _c('p', [_vm._v("This activity is appropriate for my student and I am letting the student retry.")])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', [_vm._v("Teacher:")]), _vm._v("The child has run into some trouble completing the activity. Please\n      type your initials below and select whether to:\n    ")]);
}]

export { render, staticRenderFns }